import { AxiosInstance } from 'axios'

import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'
import {
  CreateEmployeesVoterCardsRequest,
  UploadEmployeeVoterCardFileRequest,
} from '@modules/employees/types/EmployeesVoterCards/requests'

export class EmployeesVoterCardsService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesVoterCardsRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/voter-cards`, body)

    return response.data
  }

  async uploadFile({ employeeId, file }: UploadEmployeeVoterCardFileRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('file', file)

    const response = await this.instance.post(`/companies/employees/${employeeId}/voter-cards/file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesVoterCardsService = (instance: AxiosInstance) => new EmployeesVoterCardsService(instance)
